module.exports = __webpack_public_path__ + "img/banner-2.a38ab96e.jpg";